import { useEffect, useState } from "react";
import { ArrowRight, Plus, Trash2, Languages } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { applyTerms } from "@/lib/terms";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/common";

const EXAMPLES = [{ source: "Pinjaman", target: "Drop" }, { source: "Sisa Tagihan", target: "Sisa Pinjaman" }];

const PairRow = ({ p, i, onChange, onRemove }) => (
  <div className="grid grid-cols-[1fr_auto_1fr_auto] items-center gap-2" data-testid={`term-row-${i}`}>
    <Input className="h-11" placeholder="Kata asli, cth. Pinjaman" value={p.source} onChange={(e) => onChange({ ...p, source: e.target.value })} data-testid={`term-source-${i}`} />
    <ArrowRight className="h-4 w-4 text-muted-foreground" />
    <Input className="h-11" placeholder="Diganti jadi, cth. Drop" value={p.target} onChange={(e) => onChange({ ...p, target: e.target.value })} data-testid={`term-target-${i}`} />
    <Button type="button" variant="ghost" className="h-10 w-10 p-0 rounded-full text-rose-600" onClick={onRemove} aria-label="Hapus" data-testid={`term-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
  </div>
);

export default function PengaturanKataPage() {
  const [pairs, setPairs] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/terms").then((r) => setPairs(r.data.pairs)).catch((e) => { toast.error(errMsg(e)); setPairs([]); }); }, []);
  const update = (i, p) => setPairs((xs) => xs.map((x, j) => (j === i ? p : x)));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/terms", { pairs: pairs.filter((p) => p.source.trim() && p.target.trim()) });
      setPairs(data.pairs); applyTerms(data.pairs);
      toast.success("Pengaturan kata disimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!pairs) return <p className="text-muted-foreground">Memuat...</p>;
  return (
    <div className="max-w-3xl" data-no-terms>
      <PageHeader title="Pengaturan Kata" action={<Button onClick={save} disabled={busy} className="rounded-full h-11 px-6" data-testid="terms-save-button">{busy ? "Menyimpan..." : "Simpan"}</Button>} />
      <div className="panel space-y-4" data-testid="terms-panel">
        <div className="flex items-start gap-3 rounded-xl bg-primary/8 p-4 text-sm">
          <Languages className="h-5 w-5 text-primary shrink-0 mt-0.5" />
          <p>Ganti kata-kata di aplikasi dengan istilah sehari-hari. Berlaku untuk semua pengguna di kantor wilayah Anda dan seluruh kantor cabangnya. Huruf besar/kecil menyesuaikan otomatis.</p>
        </div>
        {pairs.length === 0 && <p className="text-sm text-muted-foreground text-center py-4" data-testid="terms-empty">Belum ada kata pengganti.</p>}
        {pairs.map((p, i) => <PairRow key={i} p={p} i={i} onChange={(x) => update(i, x)} onRemove={() => setPairs((xs) => xs.filter((_, j) => j !== i))} />)}
        <div className="flex flex-wrap gap-2 pt-2">
          <Button type="button" variant="outline" className="rounded-full h-10" onClick={() => setPairs((xs) => [...xs, { source: "", target: "" }])} data-testid="term-add-button"><Plus className="h-4 w-4 mr-1" />Tambah Kata</Button>
          {pairs.length === 0 && <Button type="button" variant="ghost" className="rounded-full h-10" onClick={() => setPairs(EXAMPLES)} data-testid="term-example-button">Pakai contoh</Button>}
        </div>
      </div>
    </div>
  );
}
